<template>
<div>
<div class="content_card" >
<div class="content_card_content">
<div class="grid">

<div class="col-12">
<h3 class="text-primary align-items-center flex mt-0">Tedarikçi Kodu İle Kullanıcı</h3>

<span class="p-float-label mb-4 mt-2" >
<Textarea id="suppliers"  v-model.trim="suppliercodes" class="w-full p-inputtext-sm"   rows="8" />
<label for="suppliers" >Tedarikçi Kodları</label>
</span>

</div>

<div class="col-12 flex align-items-center justify-content-end">
<Button type="button" class="p-button-primary p-button-outlined p-button-sm mt-2" label="oluştur"  @click="getData" :loading="loading"/>
</div>

</div>
</div>
</div>
</div>
</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
export default {

  name: 'SupplierContacts',

  data () {
    return {
    	suppliercodes:[],
    	contacts:[],
    	loading:false,
    }
  },
  methods:{
  	async getData()
  	{
  		this.loading = true
  		let text = this.suppliercodes.replaceAll("\n",",")
  		console.log(text)
  		let result = await this.generalApiGetWithoutLoader("get_brand_users_list_by_supplier_codes?suppliercodes="+text)
  		//let result = await fetch("https://api.verifyhub.io/get_brand_users_list_by_supplier_codes?suppliercodes="+text);
  		//result = await result.text();
  		console.log(result)
			let sheet = []
			let row = await [
			"Tedarikçi İsmi",
			"Tedarikçi Kodu(Markaya Özel)",
			"Yetkili İsmi",
			"Yetkili Email",
			]
			await sheet.push(row)
			for(let item of result)
			{
				row = await [
					item.name,
					item.suppliercode,
					item.user,
					item.email
				]
			await sheet.push(row)
			}
			let ws = await XLSX.utils.json_to_sheet(sheet)
			let wb = await XLSX.utils.book_new();
			await XLSX.utils.book_append_sheet(wb,ws,"Kullanıcılar")
			await XLSX.writeFile(wb,"Kullanıcılar.xls")
			this.loading = false
			this.suppliercodes = []
  	},
  }
}
</script>

<style lang="css" scoped>
</style>